/**
 * Utility function to show lead capture form based on the start and end date
 */

export const shouldShowLeadCaptureForm = (post: LeadCaptureForm): boolean => {
  const leadCaptureFormStartDateString =
    post?.project?.leadCaptureFormStartDate;
  const leadCaptureFormEndDateString = post?.project.leadCaptureFormEndDate;
  const leadCaptureFormId = post?.project?.leadCaptureFormId;
  let leadCaptureFormStartDate;
  let leadCaptureFormEndDate;
  const currentDate = new Date();

  if (leadCaptureFormStartDateString) {
    const leadCaptureFormStartDateParts =
      leadCaptureFormStartDateString.split('/');
    const year = +leadCaptureFormStartDateParts[2];
    const month = +leadCaptureFormStartDateParts[1] - 1;
    const day = +leadCaptureFormStartDateParts[0];
    leadCaptureFormStartDate = new Date(year, month, day);
  }

  if (leadCaptureFormEndDateString) {
    const leadCaptureFormEndDateParts = leadCaptureFormEndDateString.split('/');
    const year = +leadCaptureFormEndDateParts[2];
    const month = +leadCaptureFormEndDateParts[1] - 1;
    const day = +leadCaptureFormEndDateParts[0];
    leadCaptureFormEndDate = new Date(year, month, day);
    leadCaptureFormEndDate.setDate(leadCaptureFormEndDate.getDate() + 1);
  }

  if (
    leadCaptureFormId &&
    !leadCaptureFormStartDate &&
    !leadCaptureFormEndDate
  ) {
    return true;
  }

  if (
    leadCaptureFormId &&
    leadCaptureFormStartDate &&
    !leadCaptureFormEndDate
  ) {
    return currentDate >= leadCaptureFormStartDate;
  }

  if (
    leadCaptureFormId &&
    !leadCaptureFormStartDate &&
    leadCaptureFormEndDate
  ) {
    return currentDate < leadCaptureFormEndDate;
  }

  if (leadCaptureFormId && leadCaptureFormStartDate && leadCaptureFormEndDate) {
    return (
      currentDate >= leadCaptureFormStartDate &&
      currentDate < leadCaptureFormEndDate
    );
  }

  return false;
};

interface LeadCaptureForm {
  project: {
    leadCaptureFormId?: string;
    leadCaptureFormStartDate?: string;
    leadCaptureFormEndDate?: string;
  };
}
